import React, { useState } from 'react';
import { Chip, createTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import ValidationErrorLabel from '../../ValidationErrorLabel/ValidationErrorLabel';
import classes from './AutocompleteWithBubblesNoPlusSign.module.scss';
import { PopUpIcon } from '../../Icons';
import { MOBILE_BREAKPOINT } from '../../../../utils/constants';
import { useWindowSize } from '../../../../utils/hooks';
import colors from '../../../../scss/colors';

function AutocompleteWithBubblesNoPlusSign(props) {
  const { values, options, addHandler, block, byProperty, error, label = 'Please Select' } = props;
  const [valuesToAdd, setValuesToAdd] = useState(values);
  const [open, setOpen] = useState(false);

  const size = useWindowSize();

  const theme = createTheme({
    palette: {
      primary: {
        main: colors.PRIMARY_BLUE
      }
    },
    color: colors.WHITE
  });
  return (
    <div>
      <div className="row">
        <Autocomplete
          multiple
          disableCloseOnSelect
          variant="standard"
          open={open}
          value={valuesToAdd}
          options={options.slice(1, options.length)}
          getOptionLabel={(option) => option.label.toString()}
          popupIcon={<PopUpIcon />}
          renderOption={(params, option) => {
            return (
              !values.some((opt) => opt[byProperty]?.Name === option.label) && (
                <li {...params} className="d-flex justify-content-between align-items-center ms-3 me-1 py-2">
                  {option.label}
                </li>
              )
            );
          }}
          onChange={(event, value) => {
            setValuesToAdd(value);
            addHandler(block, value);
          }}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                color="primary"
                deleteIcon={<CloseIcon fontSize="small" color="warning" />}
                key={option.key}
                variant="outlined"
                label={option.label}
                {...getTagProps({ index })}
                sx={{
                  fontFamily: 'Gotham',
                  fontWeight: 400,
                  height: 'fit-content',
                  paddingY: '4px',
                  '& .MuiChip-label': {
                    whiteSpace: size.width > MOBILE_BREAKPOINT ? 'nowrap' : 'normal'
                  }
                }}
              />
            ))
          }
          renderInput={(params) => (
            <div className={classes.autocompleteInput}>
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              <TextField
                {...params}
                variant="outlined"
                label={label}
                size="small"
                onFocus={() => setOpen(true)}
                onBlur={() => setOpen(false)}
                onClick={() => setOpen(true)}
                InputLabelProps={{
                  style: {
                    color: colors.LIGHT_GREY,
                    fontStyle: 'normal',
                    fontWeight: 300
                  }
                }}
              />
            </div>
          )}
        />
      </div>
      {error && <ValidationErrorLabel message={`At least one ${block.toLowerCase()} must be chosen.`} />}
    </div>
  );
}
export default AutocompleteWithBubblesNoPlusSign;
